import { Heading3 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import { container, fontSize, screen, shadow, spacing } from '../../../theme';

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: ${spacing('xl4')} auto;
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl4')};
`;

export const StyledFeatureImage = styled.div`
  box-shadow: ${shadow('md')};

  @media (min-width: ${screen('md')}) {
    width: 50%;
  }

  img {
    display: block;
  }
`;

export const StyledFeatureContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  padding-top: ${spacing('sm')};
  font-size: ${fontSize('sm')};
  line-height: 1.42;

  @media (min-width: ${screen('md')}) {
    width: 50%;
    font-size: ${fontSize('md')};
    line-height: 1.5;
  }

  ${Heading3} {
    &::before {
      left: 0;
      transform: translateX(0);
    }
  }
`;

export const StyledFeature = styled.div`
  display: flex;
  flex-direction: column-reverse;
  gap: ${spacing('xl')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: flex-start;
  }

  &:last-of-type {
    @media (max-width: ${screen('mdMax')}) {
      flex-direction: column;
    }

    ${StyledFeatureImage} {
      box-shadow: unset;
    }

    ${StyledFeatureContent} {
      @media (min-width: ${screen('md')}) {
        text-align: right;
      }
    }

    ${Heading3} {
      @media (min-width: ${screen('md')}) {
        &::before {
          left: unset;
          right: 0;
        }
      }
    }
  }
`;

export const StyledTitleBadge = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('sm')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row-reverse;
  }
`;
